module.exports = __webpack_public_path__ + "img/EmployeeCV.4fb57a15.svg";